export default __webpack_public_path__ + "media/images/fancybox/fancybox-x-212acce72813fc5f97783c53fbb65b20.png";